import * as React from "react";
import { Outlet, useNavigate } from "react-router-dom";

function Transactions() {
    const [inputValue, setInputValue] = React.useState('');
    const navigate = useNavigate();
    const handleInputChange = (event) => {
        setInputValue(event.target.value);
      };
    
      const handleFormSubmit = (event) => {
        event.preventDefault();
        navigate({pathname: `${inputValue}`})
        setInputValue("");
      };
      
    return(
        <div>
        <form className="accountForm" onSubmit={handleFormSubmit}>
          <label>
            Transaction ID:
            <input type="text" value={inputValue} onChange={handleInputChange} />
          </label>
          <button type="submit">Look Up</button>
        </form>

        <Outlet />
      </div>
    )
}

export default Transactions